import React from 'react';

import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import { P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { Panel } from './styles';
import { defaultTheme } from './theme';

const Tip = (props) => {
  const theme = {
    ...defaultTheme,
    background: themeStyle.varBlueLight,
    ...props.theme,
  };

  return (
    <Panel theme={theme}>
      <InfoThickIcon />
      {props.label ? <P3>{props.label}</P3> : props.children}
    </Panel>
  );
};

export default Tip;
